import React from 'react';
import { Typography, Stack } from '@mui/material';
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AboutCard from './About/AboutCard';
import BottomBar from './BottomBar/BottomBar';
import JumpToSection from './JumpTo/JumpToSection';
import CareerSection from './Career/CareerSection';
import ProjectSection from './Project/ProjectSection';
import EducationSection from './Education/EducationSection';
import KnownTechSection from './KnownTech/KnownTechSection';
import ScrollToTop from './JumpTo/ScrollToTop';
import useIsMobile from './AppHelpers';

const theme = createTheme({
  // Customize your theme here
  palette: {
    mode: 'light',
    primary:{
      main: '#420A02'
    },
    secondary:{
      main: '#FFF5E8'
    },
  },
  typography: {
    fontFamily: [
      'Instrument serif',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});

function App() {
  const isMobile = useIsMobile()
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
    <div className="App">
      <header className='App-header' id='header'>
        <Typography variant={!isMobile?'h1':'h3'} className='mb-0'>Sarah Ward</Typography>
        <Typography variant={!isMobile?'h1':'h3'} className='mt-0'>Developer, Designer, Maker</Typography>
      </header>
      <Stack direction={'row'} spacing={2} justifyItems={'center'} className='ma-2 pt-2' >
        {!isMobile && <Stack direction={'column'} width='20vw' justifyItems={'center'} className='ma-2 pt-2' >
          <JumpToSection />
        </Stack>}
        
        <Stack direction={'column'} className='ma-2 pt-2' width={!isMobile?'80vw':'100vw'} alignItems='center' justifyItems={'center'}>
          <AboutCard></AboutCard>
          <ProjectSection></ProjectSection>
          <CareerSection></CareerSection>
          <EducationSection></EducationSection>
          <KnownTechSection></KnownTechSection>
        </Stack>

        <ScrollToTop></ScrollToTop>
      </Stack>
      <footer>
      <BottomBar></BottomBar>
      </footer>

    </div>
    </ThemeProvider>
  );
}

export default App;
